const environment = process.env.NEXT_PUBLIC_ENVIRONMENT || "";
const sentry_key = process.env.NEXT_PUBLIC_SENTRY_KEY || "";
const facebook_pixel_id = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID || "";
const aes_secret_key = process.env.NEXT_PUBLIC_AES_SECRET_KEY || "";
const razorpay_new_api_key = process.env.NEXT_PUBLIC_RAZORPAY_NEW_API_KEY || "";
const truecaller_app_key = process.env.NEXT_PUBLIC_TRUECALLER_APP_KEY || "";
const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL || "";
const contactUsTime = process?.env?.NEXT_PUBLIC_CONTACT_US_TIME || "";

export {
  environment,
  sentry_key,
  facebook_pixel_id,
  aes_secret_key,
  razorpay_new_api_key,
  truecaller_app_key,
  apiBaseUrl,
  contactUsTime,
};
